angular.module('iw.frontyard.signup')
    .service('SignupPage', function (SignupAPIHelper,
                                     IwocaSiteHelper,
                                     SignupEmailValidityRegExp,
                                     SignupLendingAPIHelper,
                                     $window) {

        const PRODUCT_TYPES = {
            DEFAULT: null,
            CREDIT_LINE: 'CREDIT_LINE',
            TERM_LOAN: 'TERM_LOAN',
        };

        class SignupPage {
            constructor() {
                this.setAsDefaultProduct();

                this.email = null;
                this.urgency = 0;
                this.requestedAmount = null;
                this.reason = null;
                this.detailedReason = null;
                this.showReasons = false;
                this.marketingEmails = false;
                this.personUID = SignupAPIHelper.generateUUID();
                this.emailUID = SignupAPIHelper.generateUUID();
                this.choices = SignupLendingAPIHelper.getChoices();
                this.selectedChoice = null;
                this.showExtraFields = false;
                this.showOtherReason = false;
                this.isPending = false;
                this.isPendingEmailValidity = false;
                this.isEmailValidForServer = null;
                this.serverVerifiedEmails = {};
                this.isInvalidOnCreateAccount = false;
                this.hasToValidateExtraFields = false;
                this.isCreateAccountEnabled = false;
                this.hasError = false;
                this.emailValidityRegExp = SignupEmailValidityRegExp;
            }

            setAsDefaultProduct() {
                this.duration = null;
                this.MIN_REQUESTED_AMOUNT = 1;
                this.productType = PRODUCT_TYPES.DEFAULT;
                this.MIN_LOAN_SIZE = $window.MIN_LOAN_SIZE;
                this.MAX_LOAN_SIZE = $window.MAX_LOAN_SIZE;
                this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                this.FORMATTED_MAX_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MAX_LOAN_SIZE);
            }

            setAsCreditLineProduct() {
                this.MIN_REQUESTED_AMOUNT = 1;
                this.duration = 12;
                this.productType = PRODUCT_TYPES.CREDIT_LINE;
                this.MIN_LOAN_SIZE = $window.MIN_LOAN_SIZE;
                this.MAX_LOAN_SIZE = $window.MAX_LOAN_SIZE;
                this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                this.FORMATTED_MAX_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MAX_LOAN_SIZE);
            }

            setAsTermLoanProduct() {
                // TODO: we now have different min loan sizes within term loans (broker and non broker) so an extra
                // context variable should be exposed from the backend to represent this
                this.MIN_REQUESTED_AMOUNT = 25000;
                this.duration = $window.TERM_LOAN_MAX_LOAN_TERM;
                this.productType = PRODUCT_TYPES.TERM_LOAN;
                this.MIN_LOAN_SIZE = 25000;
                this.MAX_LOAN_SIZE = $window.TERM_LOAN_MAX_LOAN_SIZE;
                this.FORMATTED_MIN_REQUESTED_AMOUNT = SignupLendingAPIHelper.formatNumber(this.MIN_REQUESTED_AMOUNT);
                this.FORMATTED_MIN_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MIN_LOAN_SIZE);
                this.FORMATTED_MAX_LOAN_SIZE = SignupLendingAPIHelper.formatNumber(this.MAX_LOAN_SIZE);
            }

            setAsApproveInFuture() {
                this.urgency = 1;
                this.showExtraFields = false;
                this.showReasons = false;
                this.updateCreateAccountValidity();
            }

            setAsNotUrgent() {
                this.urgency = 2;
                this.showExtraFields = true;
                this.updateCreateAccountValidity();
            }

            setAsUrgent() {
                this.urgency = 3;
                this.showExtraFields = true;
                this.updateCreateAccountValidity();
            }

            keyPressOnButtons(event) {
                if (event.keyCode === 39) {
                    switch (this.urgency) {
                        case 2:
                            this.setAsApproveInFuture();
                            break;
                        case 3:
                            this.setAsNotUrgent();
                            break;
                    }
                } else if (event.keyCode === 37) {
                    switch (this.urgency) {
                        case 1:
                            this.setAsNotUrgent();
                            break;
                        case 2:
                            this.setAsUrgent();
                            break;
                    }
                }
            }

            redirectToLogin() {
                IwocaSiteHelper.closeOverlay();
                IwocaSiteHelper.openLoginOverlay(this.email);
            }

            onClickSendEmails() {
                this.marketingEmails = !this.marketingEmails;
            }

            updateCreateAccountValidity() {
                this.isCreateAccountEnabled = this.isValid();
            }

            onEmailChange() {
                this.isEmailValidForServer = null;
                this.updateCreateAccountValidity();
            }

            onReasonChange(choice) {
                this.reason = choice.value;
                this.selectedChoice = choice.name
                this.showOtherReason = (choice.value === 'other');
                this.toggleReasons();
                this.updateCreateAccountValidity();
            }

            toggleReasons() {
                this.showReasons = !this.showReasons;
            }

            blurReasons() {
                this.blurOtherReasons = true;
            }

            openReasons() {
                this.blurOtherReasons = false;
                this.showReasons = true;
            }

            isValid() {
                switch (this.urgency) {
                    case 1:
                        return this.isValidForApprovalInFuture();
                    default:
                        return this.isValidForApproval();
                }
            }

            isValidForApprovalInFuture() {
                return this.isValidEmail()
                    && this.isEmailValidForServer !== false
                    && this.isValidRequestedAmount()
                    && this.urgency === 1;
            }

            isValidForApproval() {
                return this.isValidEmail()
                    && this.isEmailValidForServer !== false
                    && this.isValidRequestedAmount()
                    && this.isValidReason()
                    && this.urgency > 1;
            }

            isValidReason() {
                if (this.isValidReasonAsOther()) {
                    return true;
                } else if (this.isValidReasonAsSelectedChoice()) {
                    return true;
                }
                return false;
            }

            isValidReasonAsSelectedChoice() {
                return angular.isDefined(this.reason)
                    && this.reason !== null
                    && this.reason !== 'other';
            }

            isValidReasonAsOther() {
                return this.reason === 'other'
                    && angular.isString(this.detailedReason)
                    && this.detailedReason.length > 0;
            }


            isValidEmail() {
                return angular.isString(this.email)
                    && this.emailValidityRegExp.test(this.email)
                    && !!this.serverVerifiedEmails[this.email];
            }

            isValidRequestedAmount() {
                if (this.productType === 'TERM_LOAN') {
                    return angular.isNumber(this.requestedAmount)
                        && this.requestedAmount >= this.MIN_REQUESTED_AMOUNT
                        && this.requestedAmount <= this.MAX_LOAN_SIZE;
                }

                return angular.isNumber(this.requestedAmount)
                    && this.requestedAmount > 0
                    && this.requestedAmount <= this.MAX_LOAN_SIZE;
            }

            validateRequestedAmount() {
                this.isValidatedRequestedAmount = true;
                this.form.requested_amount.$validate();
            }

            validateSingleInput(fieldName) {
                //TODO: deprecated
                this.form[fieldName].$validate();
            }

            checkEmailValidity() {
                var self = this;

                if (!self.form.email.$invalid) {
                    self.isPendingEmailValidity = true;
                    SignupAPIHelper.isValidEmail(self.email)
                        .then(function onSuccess(response) {
                            self.isEmailValidForServer = response.data;
                            self.serverVerifiedEmails[self.email] = response.data;
                        }, function onError() {
                            self.isEmailValidForServer = null;
                            self.serverVerifiedEmails[self.email] = false;
                        })
                        .finally(function () {
                            self.isPendingEmailValidity = false;
                            self.updateCreateAccountValidity();
                        });
                } else {
                    self.isPendingEmailValidity = false;
                    self.isValidatedEmail = true;
                    self.form.email.$validate();
                }
            }

            createAccount() {
                if (this.isValid()) {
                    this.isInvalidOnCreateAccount = false;
                    this.hasToValidateExtraFields = false;

                    this.createAccountAndRedirect();
                } else {
                    this.isInvalidOnCreateAccount = true;
                    this.checkEmailValidity();

                    if (this.showExtraFields) {
                        this.hasToValidateExtraFields = true;
                    }
                }
            }

            createAccountAndRedirect() {
                var self = this;

                self.isPending = true;
                const customerState = { data: SignupAPIHelper.serializeDataToSend(self) };

                let stateKey = null;
                SignupAPIHelper.postData(customerState)
                .then(function onSuccess(response) {
                        stateKey = response.data.data.state_key;

                        if ($window.USER_IS_BROKER === true && $window.SITE_CODE === 'uk') {
                            const applicationState = { data: SignupAPIHelper.serializeApplication(self) };
                            return SignupAPIHelper.postApplication(stateKey, applicationState);
                        }
                    })
                    .then(function () {
                        const url = SignupAPIHelper.getSignupURL(stateKey);
                        self.hasError = false;
                        IwocaSiteHelper.redirectToInternalPage(url);
                    }, function onError(response) {
                        self.hasError = true;
                    })
                    .finally(function () {
                        self.isPending = false;
                    });
            }
        }

        return SignupPage;
    });
